import styled from 'styled-components';
import {dFlex, dFlexCenter} from '../../../../globalVariables/GlobalVariables';

export const grid = styled.div`
    ${dFlex};
    flex-wrap: wrap;
    align-items: stretch;
    gap: var(--space-md);
    padding: var(--space-md);
    background: var(--TA-color-bg-base);
`;

export const empty = styled.div`
    flex: 1;
    ${dFlexCenter};
    padding: var(--space-3xl);
    color: var(--TA-color-text-subtle);
    font-family: Assistant, sans-serif;
    font-size: var(--font-size-body);
`;
